import { FC } from "react";
import { copy } from "shared/assets";
import { FancyButtonLink } from "../Link";

import { StyledFooter } from "./styles";

export interface FooterProps {
  handleOpenCookies: () => void;
}

export const Footer: FC<FooterProps> = ({ handleOpenCookies }) => (
  <StyledFooter>
    <FancyButtonLink muted={true} onClick={handleOpenCookies}>
      {copy.cookieNotice.cta}
    </FancyButtonLink>

    <FancyButtonLink
      muted={true}
      onClick={() => window.open(copy.authFormFields.consent.url, "_blank")}
    >
      {copy.termsOfUse}
    </FancyButtonLink>
  </StyledFooter>
);
